import { Header } from "@/components/alkeon/Header";
import { Hero } from "@/components/alkeon/Hero";
import { Marquee } from "@/components/alkeon/Marquee";
import { Collection } from "@/components/alkeon/Collection";
import { Philosophy } from "@/components/alkeon/Philosophy";
import { Atelier } from "@/components/alkeon/Atelier";
import { Footer } from "@/components/alkeon/Footer";

export default function Home() {
  return (
    <main className="bg-ink min-h-screen" data-testid="home-page">
      <Header />
      <Hero />
      <Marquee />
      <Collection />
      <Philosophy />
      <Atelier />
      <Footer />
    </main>
  );
}
